import type { ConstValues } from '@openx/types/helpers.ts';
import type { DealLibraryItem, MappedSortCriteria } from '../../../types/index.ts';
import type { ColumnKey } from '../constants.ts';
import { filterList } from './filterList.ts';

export type ListState = {
  criteria: MappedSortCriteria;
  dealTemplates: DealLibraryItem[];
  loadingList: boolean;
};

export const ListActions = {
  SET_LIST_DATA: 'SET_LIST_DATA',
  SET_LOADING: 'SET_LOADING',
} as const;
export type ListActions = ConstValues<typeof ListActions>;

export type ListAction =
  | {
      type: typeof ListActions.SET_LIST_DATA;
      payload: Omit<ListState, 'loadingList'>;
    }
  | {
      type: typeof ListActions.SET_LOADING;
    };

export const listReducer = (state: ListState, action: ListAction): ListState => {
  switch (action.type) {
    case ListActions.SET_LIST_DATA: {
      const filteredList = filterList(
        action.payload.dealTemplates,
        action.payload.criteria.phrase,
        action.payload.criteria.sort.direction,
        action.payload.criteria.sort.column as ColumnKey
      );

      const maxPageNumber = Math.ceil(filteredList.length / action.payload.criteria.pagination.pageSize);
      const pageNumber = Math.min(action.payload.criteria.pagination.pageNumber, maxPageNumber);

      const displayList = filteredList.slice(
        (pageNumber - 1) * action.payload.criteria.pagination.pageSize,
        action.payload.criteria.pagination.pageNumber * action.payload.criteria.pagination.pageSize
      );

      return {
        criteria: {
          pagination: {
            ...action.payload.criteria.pagination,
            pageNumber: pageNumber || 1,
            totalCount: filteredList.length,
          },
          phrase: action.payload.criteria.phrase,
          sort: action.payload.criteria.sort,
        },
        dealTemplates: displayList,
        loadingList: false,
      };
    }

    case ListActions.SET_LOADING: {
      return {
        ...state,
        loadingList: true,
      };
    }

    default:
      return state;
  }
};
